import LayoutBase from "@/components/layouts/LayoutBase.vue";
import { ROLE_PERMISSION } from '../constants/index';

export default [
    // {
    //     path: "/test",
    //     name: "Test",
    //     component: () =>
    //         import(/* webpackChunkName: "test" */ "@/views/Test.vue"),
    // },
    {
        path: "/",
        name: "Home",
        component: () =>
            import(
                /* webpackChunkName: "home" */ "@/views/dashboard/home/index.vue"
            ),
        meta: { accessKey: ROLE_PERMISSION.VIEW_HOME },
    },
    {
        path: "/user-management",
        component: LayoutBase,
        children: [
            /* CUSTOMER */
            {
                path: "customers",
                name: "Customers",
                component: () =>
                    import(
                        /* webpackChunkName: "customers" */ "@/views/dashboard/users/customers/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_CUSTOMER_LIST },
            },
            {
                path: "customers/view/:id",
                name: "CustomerProfile",
                component: () =>
                    import(
                        /* webpackChunkName: "customers-profile" */ "@/views/dashboard/users/customers/CustomerProfile.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_CUSTOMER },
            },
            {
                path: "customers/add",
                name: "CustomerFormAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "customers-form" */ "@/views/dashboard/users/customers/CustomerForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.ADD_CUSTOMER },
            },
            {
                path: "customers/edit/:id",
                name: "CustomerFormEdit",
                component: () =>
                    import(
                        /* webpackChunkName: "customers-form" */ "@/views/dashboard/users/customers/CustomerForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.EDIT_CUSTOMER },
            },
            /* ADMIN */
            {
                path: "admin",
                name: "Admin",
                component: () =>
                    import(
                        /* webpackChunkName: "admin" */ "@/views/dashboard/users/admin/index.vue"
                    ),
                meta: {  accessKey: ROLE_PERMISSION.VIEW_ADMIN_LIST  },
            },
            {
                path: "admin/view/:id",
                name: "AdminProfile",
                component: () =>
                    import(
                        /* webpackChunkName: "admin-profile" */ "@/views/dashboard/users/admin/AdminProfile.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_ADMIN },
            },
            {
                path: "admin/:type",
                name: "AdminFormAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "admin-form" */ "@/views/dashboard/users/admin/AdminForm.vue"
                    ),
                meta: {  accessKey: ROLE_PERMISSION.ADD_ADMIN  },
            },
            {
                path: "admin/:type/:id",
                name: "AdminFormEdit",
                component: () =>
                    import(
                        /* webpackChunkName: "admin-form" */ "@/views/dashboard/users/admin/AdminForm.vue"
                    ),
                meta: {  accessKey: ROLE_PERMISSION.EDIT_ADMIN  },
            },
            /* ROLE */
            {
                path: "role",
                name: "Role",
                component: () =>
                    import(
                        /* webpackChunkName: "role" */ "@/views/dashboard/users/role/index.vue"
                    ),
                meta: {  accessKey: ROLE_PERMISSION.VIEW_ROLE_LIST  },
            },
            {
                path: "role/add",
                name: "RoleFormAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "role-form" */ "@/views/dashboard/users/role/RoleForm.vue"
                    ),
                meta: {  accessKey: ROLE_PERMISSION.ADD_ROLE  },
            },
            {
                path: "role/edit/:id",
                name: "RoleFormEdit",
                component: () =>
                    import(
                        /* webpackChunkName: "role-form" */ "@/views/dashboard/users/role/RoleForm.vue"
                    ),
                meta: {  accessKey: ROLE_PERMISSION.EDIT_ROLE  },
            },
            /* ARCHIVE */
            {
                path: "archive",
                name: "Archive",
                component: () =>
                    import(
                        /* webpackChunkName: "archive" */ "@/views/dashboard/users/archive/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_ARCHIVE_LIST },
            },
            {
                path: "admin/view/:table/:id",
                name: "ArchiveAdminProfile",
                component: () =>
                    import(
                        /* webpackChunkName: "archive-admin-profile" */ "@/views/dashboard/users/admin/AdminProfile.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_ARCHIVE },
            },
            {
                path: "customers/:table/:id",
                name: "ArchiveCustomerProfile",
                component: () =>
                    import(
                        /* webpackChunkName: "archive-customers-profile" */ "@/views/dashboard/users/customers/CustomerProfile.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_ARCHIVE },
            },
        ],
    },
    {
        path: "/canon-products",
        component: LayoutBase,
        children: [
            /* CANON PRODUCTS */
            {
                path: "products",
                name: "Products",
                component: () =>
                    import(
                        /* webpackChunkName: "products" */ "@/views/dashboard/products/all-products/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_CANON_PRODUCT_LIST },
            },
            {
                path: "products/view/:id",
                name: "Product",
                component: () =>
                    import(
                        /* webpackChunkName: "product" */ "@/views/dashboard/products/all-products/Product.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_CANON_PRODUCT },
            },
            {
                path: "product/add",
                name: "ProductsFormAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "products-form" */ "@/views/dashboard/products/all-products/ProductForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.ADD_CANON_PRODUCT },
            },
            {
                path: "product/edit/:id",
                name: "ProductsFormEdit",
                component: () =>
                    import(
                        /* webpackChunkName: "products-form" */ "@/views/dashboard/products/all-products/ProductForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.EDIT_CANON_PRODUCT },
            },
            /* QR/PIN CODE */
            {
                path: "pin-code",
                name: "PinCode",
                component: () =>
                    import(
                        /* webpackChunkName: "pin-code" */ "@/views/dashboard/products/pin-code/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_PIN_CODE_LIST },
            },
            {
                path: "pin-code/add",
                name: "PinCodeFormAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "pin-code-form" */ "@/views/dashboard/products/pin-code/PinCodeForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.ADD_PIN_CODE },
            },
            {
                path: "pin-code/edit/:id",
                name: "PinCodeFormEdit",
                component: () =>
                    import(
                        /* webpackChunkName: "pin-code-form" */ "@/views/dashboard/products/pin-code/PinCodeForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.EDIT_PIN_CODE },
            },
            {
                path: "pin-code/bulk-editor",
                name: "PinCodeBulkEditor",
                component: () =>
                    import(
                        /* webpackChunkName: "pin-code-bulk-editor" */ "@/views/dashboard/products/pin-code/PinCodeBulkEditor.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.EDIT_PIN_CODE },
            },
        ],
    },
    {
        path: "/promo",
        component: LayoutBase,
        children: [
            {
                path: "",
                name: "Promos",
                component: () =>
                    import(
                        /* webpackChunkName: "promos" */ "@/views/dashboard/promo/promo/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_PROMO_LIST },
            },
            {
                path: "view/:id",
                name: "Promo",
                component: () =>
                    import(
                        /* webpackChunkName: "promo" */ "@/views/dashboard/promo/promo/PromoView.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_PROMO },
            },
            {
                path: "add",
                name: "PromoFormAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "promo-form" */ "@/views/dashboard/promo/promo/PromoForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.ADD_PROMO },
            },
            {
                path: "edit/:id",
                name: "PromoFormEdit",
                component: () =>
                    import(
                        /* webpackChunkName: "promo-form" */ "@/views/dashboard/promo/promo/PromoForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.EDIT_PROMO },
            },
        ],
    },
    {
        path: "/ads",
        component: LayoutBase,
        children: [
            {
                path: "",
                name: "Ads",
                component: () =>
                    import(
                        /* webpackChunkName: "advertisements" */ "@/views/dashboard/promo/ads/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_ADVERTISEMENT_LIST },
            },
            {
                path: "view/:id",
                name: "AdvertisementView",
                component: () =>
                    import(
                        /* webpackChunkName: "advertisement" */ "@/views/dashboard/promo/ads/AdvertisementView.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_ADVERTISEMENT },
            },
            {
                path: "add",
                name: "AdvertisementFormAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "advertisement-form" */ "@/views/dashboard/promo/ads/AdvertisementForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.ADD_ADVERTISEMENT },
            },
            {
                path: "edit/:id",
                name: "AdvertisementFormEdit",
                component: () =>
                    import(
                        /* webpackChunkName: "advertisement-form" */ "@/views/dashboard/promo/ads/AdvertisementForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.EDIT_ADVERTISEMENT },
            },
        ],
    },
    {
        path: "/product-registrations",
        component: LayoutBase,
        children: [
            /* CMP */
            {
                path: "cmp",
                name: "Cmp",
                component: () =>
                    import(
                        /* webpackChunkName: "cmp" */ "@/views/dashboard/registration/cmp/index.vue"
                    ),
                meta: { 
                    accessKey: [
                        ROLE_PERMISSION.VIEW_CMP_REGISTRATION_LIST, 
                        ROLE_PERMISSION.VALIDATE_CMP_REGISTRATION, 
                        ROLE_PERMISSION.AWARD_CMP_REGISTRATION, 
                        ROLE_PERMISSION.APPROVAL_CMP_REGISTRATION, 
                        ROLE_PERMISSION.APPROVED_CMP_REGISTRATION, 
                        ROLE_PERMISSION.REJECTED_CMP_REGISTRATION,
                        ROLE_PERMISSION.IMPORTED_CMP_REGISTRATION,
                    ],
                    accessType: 'check once',
                },
            },
            {
                path: "cmp/view/:id",
                name: "CmpView",
                component: () =>
                    import(
                        /* webpackChunkName: "cmp-view" */ "@/views/dashboard/registration/cmp/CmpView.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_CMP_REGISTRATION },
            },
            {
                path: "cmp/add",
                name: "CmpFormAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "cmp-form" */ "@/views/dashboard/registration/cmp/CmpForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.ADD_CMP_REGISTRATION },
            },
            {
                path: "cmp/edit/:id",
                name: "CmpFormEdit",
                component: () =>
                    import(
                        /* webpackChunkName: "cmp-form" */ "@/views/dashboard/registration/cmp/CmpForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_CMP_REGISTRATION },
            },
            /* NONCMP */
            {
                path: "non-cmp",
                name: "NonCmp",
                component: () =>
                    import(
                        /* webpackChunkName: "non-cmp" */ "@/views/dashboard/registration/non-cmp/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_NONCMP_REGISTRATION_LIST },
            },
            {
                path: "non-cmp/view/:id",
                name: "NonCmpView",
                component: () =>
                    import(
                        /* webpackChunkName: "non-cmp-view" */ "@/views/dashboard/registration/non-cmp/NonCmpView.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_NONCMP_REGISTRATION },
            },
        ],
    },
    {
        path: "/warranty",
        name: "Warranty",
        component: () =>
            import(
                /* webpackChunkName: "warranty-masterlist" */ "@/views/dashboard/warranty/index.vue"
            ),
        meta: { accessKey: ROLE_PERMISSION.VIEW_WARRANTY_LIST },
    },
    {
        path: "/warranty/view/:id",
        name: "WarrantyView",
        component: () =>
            import(
                /* webpackChunkName: "warranty-view" */ "@/views/dashboard/warranty/WarrantyView.vue"
            ),
        meta: { accessKey: ROLE_PERMISSION.VIEW_WARRANTY },
    },
    {
        path: "/warranty/add",
        name: "WarrantyFormAdd",
        component: () =>
            import(
                /* webpackChunkName: "warranty-add" */ "@/views/dashboard/warranty/WarrantyForm.vue"
            ),
        meta: { accessKey: ROLE_PERMISSION.ADD_WARRANTY },
    },
    {
        path: "/rewards",
        name: "Rewards",
        component: () =>
            import(
                /* webpackChunkName: "rewards" */ "@/views/dashboard/rewards/index.vue"
            ),
        meta: { accessKey: ROLE_PERMISSION.VIEW_REWARD_LIST },
    },
    {
      path: '/service-center',
      name: 'ServiceCenter',
      component: () => import(/* webpackChunkName: "service-centers" */ '@/views/dashboard/service/index.vue'),
      meta: { accessKey: ROLE_PERMISSION.VIEW_SERVICE_CENTER_LIST },
    },
    {
      path: '/service-center/view/:id',
      name: 'ServiceCenterView',
      component: () => import(/* webpackChunkName: "service-center" */ '@/views/dashboard/service/ServiceCenterView.vue'),
      meta: { accessKey: ROLE_PERMISSION.VIEW_SERVICE_CENTER_LIST },
    },
    {
        path: '/service-center/edit/:id',
        name: 'ServiceCenterEdit',
        component: () => import(/* webpackChunkName: "service-center-form" */ '@/views/dashboard/service/ServiceCenterForm.vue'),
        meta: { accessKey: ROLE_PERMISSION.VIEW_SERVICE_CENTER_LIST },
    },
    {
        path: "/product-repair",
        component: LayoutBase,
        children: [
            {
                path: "",
                name: "ProductRepairs",
                component: () =>
                    import(
                        /* webpackChunkName: "product-repairs" */ "@/views/dashboard/repair/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_PRODUCT_REPAIR_LIST },
            },
            {
                path: "view/:id",
                name: "ProductRepair",
                component: () =>
                    import(
                        /* webpackChunkName: "product-repair" */ "@/views/dashboard/repair/ProductRepairView.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_PRODUCT_REPAIR },
            },
            {
                path: "add",
                name: "ProductRepairFormAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "product-repair-form" */ "@/views/dashboard/repair/ProductRepairForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.ADD_PRODUCT_REPAIR },
            },
            {
                path: "edit/:id",
                name: "ProductRepairFormEdit",
                component: () =>
                    import(
                        /* webpackChunkName: "product-repair-form" */ "@/views/dashboard/repair/ProductRepairForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.EDIT_PRODUCT_REPAIR },
            },
        ],
    },
    {
        path: "/settings",
        component: LayoutBase,
        children: [
            /* CMS PAGES */
            {
                path: "cms-pages",
                name: "CmsPages",
                component: () =>
                    import(
                        /* webpackChunkName: "cms-pages" */ "@/views/dashboard/settings/cms-pages/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_CMS_PAGES },
            },
            {
                path: "cms-pages/about-us",
                name: "CmsPagesAboutUs",
                component: () =>
                    import(
                        /* webpackChunkName: "cms-pages-about-us" */ "@/views/dashboard/settings/cms-pages/AboutUs.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_ABOUT_US },
            },
            {
                path: "cms-pages/privacy-policy",
                name: "CmsPagesPrivacyPolicy",
                component: () =>
                    import(
                        /* webpackChunkName: "cms-pages-privacy-policy" */ "@/views/dashboard/settings/cms-pages/PrivacyPolicy.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_PRIVACY_POLICY },
            },
            {
                path: "cms-pages/terms-and-conditions",
                name: "CmsPagesTermsAndConditions",
                component: () =>
                    import(
                        /* webpackChunkName: "cms-pages-terms-and-conditions" */ "@/views/dashboard/settings/cms-pages/TermsAndConditions.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_TERMS_AND_CONDITIONS },
            },
            {
                path: "cms-pages/questions",
                name: "CmsPagesQuestions",
                component: () =>
                    import(
                        /* webpackChunkName: "cms-pages-questions" */ "@/views/dashboard/settings/cms-pages/Questions.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_FAQ },
            },
            /* ACTIVITY LOGS */
            {
                path: "activity-logs",
                name: "ActivityLogs",
                component: () =>
                    import(
                        /* webpackChunkName: "activity-logs" */ "@/views/dashboard/settings/activity-logs/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_ACTIVITY_LOGS_LIST },
            },
            /* APPROVAL ACCESS */
            {
                path: "approval-access",
                name: "ApprovalAccess",
                component: () =>
                    import(
                        /* webpackChunkName: "approval-access" */ "@/views/dashboard/settings/approval-access/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_APPROVAL_ACCESS },
            },
            
            /* DOWNLOAD LOGS */
            {
                path: "download-logs",
                name: "DownloadLogs",
                component: () =>
                    import(
                        /* webpackChunkName: "download-logs" */ "@/views/dashboard/settings/download-logs/Index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_DOWNLOAD_LOGS_LIST },
            },
        ],
    },
    {
        path: "/notifications",
        component: LayoutBase,
        children: [
            {
                path: "",
                name: "Notifications",
                component: () =>
                    import(
                        /* webpackChunkName: "notifications" */ "@/views/dashboard/notifications/index.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.VIEW_NOTIFICATION_LIST },
            },
            {
                path: "add",
                name: "NotificationFormAdd",
                component: () =>
                    import(
                        /* webpackChunkName: "notification-form" */ "@/views/dashboard/notifications/NotificationForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.ADD_NOTIFICATION },
            },
            {
                path: "edit/:id",
                name: "NotificationFormEdit",
                component: () =>
                    import(
                        /* webpackChunkName: "notification-form" */ "@/views/dashboard/notifications/NotificationForm.vue"
                    ),
                meta: { accessKey: ROLE_PERMISSION.EDIT_NOTIFICATION },
            },
        ],
    },
    {
        path: "/view-all-notifications",
        component: LayoutBase,
        children: [
            {
                path: "",
                name: "View All Notifications",
                component: () =>
                    import(
                        /* webpackChunkName: "view all notifications" */ "@/views/dashboard/view-all-notifications/index.vue"
                    ),
                meta: { 
					// TODO: when need, ask BE to provide and add `VIEW_ALL_NOTIFICATION` in the permissions API
					accessKey: ROLE_PERMISSION.VIEW_ALL_NOTIFICATION
				},
            },
        ],
    },
    {
        path: "/account",
        component: LayoutBase,
        children: [
            {
                path: "login",
                name: "Login",
                component: () =>
                    import(
                        /* webpackChunkName: "login" */ "@/views/auth/Login.vue"
                    ),
                meta: { public: true },
            },
            {
                path: "forgot-password",
                name: "ForgotPassword",
                component: () =>
                    import(
                        /* webpackChunkName: "forgot-password" */ "@/views/auth/ForgotPassword.vue"
                    ),
                meta: { public: true },
            },
            {
                path: "forgot-password/resend",
                name: "ForgotPasswordResend",
                component: () =>
                    import(
                        /* webpackChunkName: "forgot-password" */ "@/views/auth/ForgotPasswordResend.vue"
                    ),
                meta: { public: true },
            },
            {
                path: "reset-password/:token",
                name: "ResetPassword",
                component: () =>
                    import(
                        /* webpackChunkName: "reset-password" */ "@/views/auth/ResetPassword.vue"
                    ),
                meta: { public: true },
            },
        ],
    },
    {
        path: "/terms-of-service",
        name: "Terms",
        component: () =>
            import(/* webpackChunkName: "terms" */ "@/views/utility/Terms.vue"),
        meta: { public: true },
    },
    {
        path: "/privacy-policy",
        name: "PrivacyPolicy",
        component: () =>
            import(
                /* webpackChunkName: "privacy-policy" */ "@/views/utility/PrivacyPolicy.vue"
            ),
        meta: { public: true },
    },
    {
        path: "/mobile-app",
        name: "MobileApp",
        component: () =>
            import(
                /* webpackChunkName: "mobile-app" */ "@/views/utility/Marketing.vue"
            ),
        meta: { public: true },
    },
    {
        path: "/recaptcha",
        name: "Captcha",
        component: () =>
            import(/* webpackChunkName: "captcha" */ "@/views/utility/Captcha.vue"),
        meta: { public: true, error: true },
    },
    {
        path: "/401",
        name: "Error401",
        component: () =>
            import(/* webpackChunkName: "error" */ "@/views/errors/401.vue"),
        meta: { public: true, error: true },
    },
    {
        path: "/422",
        name: "Error422",
        component: () =>
            import(/* webpackChunkName: "error" */ "@/views/errors/422.vue"),
        meta: { public: true, error: true },
    },
    {
        path: "/498/:type?",
        name: "Error498",
        component: () =>
            import(/* webpackChunkName: "error" */ "@/views/errors/498.vue"),
        meta: { public: true, error: true },
    },
    {
        path: "/500",
        name: "Error500",
        component: () =>
            import(/* webpackChunkName: "error" */ "@/views/errors/500.vue"),
        meta: { public: true, error: true },
    },
    {
        path: "*",
        name: "Error404",
        component: () =>
            import(/* webpackChunkName: "error" */ "@/views/errors/404.vue"),
        meta: { public: true, error: true },
    },
];
